import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import { ConfigContext } from "../context/GlobalContext";
import * as actionType from "../context/actions";
import DeleteInvoiceView from "./DeleteInvoiceView";
import PaginationView from "./PaginationView";
import { FilterdData } from "../helper/FilterdData";
import DataNotFoundView from "./DataNotFoundView";
import { useNavigate } from "react-router-dom";
import { Languages } from "../Utils/Languages";
import { PremiumFeatureOnlyModal } from "./PremiumFeatureOnlyModal";
import DeleteProformaInvoiceView from "./DeleteProformaInvoiceView";
import { AddInvoice, AddProformaInvoice, AddQuotation, DeleteQuotation, EditProformaInvoice, EditQuotation } from "../data";
import DeleteQuotationView from "./DeleteQuotationView";
import EditQuotationDataInLocal from "../data/LocalStorage/Quotation/EditQuotationDataInLocal";
import { toast } from "react-toastify";
import GetQuotationDataFirebase from "../data/Firebase/Quotation/GetQuotationDataFirebase";
import GetQuotationDataLocal from "../data/LocalStorage/Quotation/GetQuotationDataLocal";
import { Modal, Button } from "react-bootstrap";
import { Tooltip } from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { FreePlanLimitReachedModal } from "./FreePlanLimitReached";
import { resolveAuditName } from "../Utils/audit_helper";
import Currancy from "../Utils/currency.json";


const QuotationTableDataLayer = ({ InvoicesData, selectedBusiness }) => {
    const navigate = useNavigate();
    const { state, dispatch } = useContext(ConfigContext);
    const dropdownRef = useRef(null);
    const [open, setOpen] = useState(false);

    const [filterdInvoiceData, setFilterdInvoiceData] = useState(InvoicesData);
    const [enrichedInvoices, setEnrichedInvoices] = useState([]);
    const [isDisplayPrimiumFeatureModel, setIsDisplayPrimiumFeatureModel] = useState(false)
    const [showAlreadyInvoiceModal, setShowAlreadyInvoiceModal] = useState(false);
    const [isDisplayFreePlanReachedModel, setIsDisplayFreePlanReachedModel] = useState(false)

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);

    useEffect(() => {
        setFilterdInvoiceData(FilterdData(state, InvoicesData, "creationDate"));
    }, [state])

    // const handleDropdownClick = (e, row) => {
    //     e.preventDefault();
    //     if (row?.status === "Invoice") {
    //         setShowAlreadyInvoiceModal(true);
    //     } else {
    //         const dropdown = e.currentTarget.nextElementSibling;
    //         if (dropdown) dropdown.classList.toggle("show");
    //     }
    // };

    const enrichInvoiceData = (quotations) => {
        return quotations.map((quotation, index) => {
            // Find customer name
            const matchedCustomer = state?.CUSTOMERS?.find(
                (cust) => cust.customerId?.toString() === quotation.customerId?.toString()
            );
            const customerName = matchedCustomer?.customer || "Unknown";

            // Format issued date (guard against null/invalid dates)
            let issuedDate = "";
            try {
                const rawDate = quotation.date;
                if (rawDate) {
                    let ts = parseInt(rawDate);
                    if (!isNaN(ts)) {
                        if (ts.toString().length <= 10) ts *= 1000;
                        const d = new Date(ts);
                        if (!isNaN(d.getTime())) {
                            issuedDate = d.toDateString();
                        }
                    }
                }
            } catch (e) { issuedDate = ""; }

            // ✅ REALTIME STATUS CALCULATION

            const isInvoice = state?.INVOICES?.some(
                (inv) => inv.invoiceId === quotation.invoiceId
            );

            const isProforma = state?.PROFORMAINVOICES?.some(
                (p) => p.invoiceId === quotation.invoiceId
            );

            const currentStatus = String(quotation?.status || "").toLowerCase();
            console.log("currentStatus", currentStatus);
            let statusText = "Pending";

            if (isInvoice || currentStatus === "invoice") {
                statusText = "Invoice";
            } else if (isProforma || currentStatus === "proforma invoice" || currentStatus === "proforma") {
                statusText = "Proforma Invoice";
            }

            // Calculate due status
            let dueStatus = "No Due Date";
            if (quotation.dueDate) {
                let dueDateNum = parseInt(quotation.dueDate);
                if (dueDateNum.toString().length === 10) {
                    dueDateNum = dueDateNum * 1000;
                }
                const dueDate = new Date(dueDateNum);
                const today = new Date();
                dueDate.setHours(0, 0, 0, 0);
                today.setHours(0, 0, 0, 0);
                const diffTime = dueDate.getTime() - today.getTime();
                const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

                if (diffDays === 0) {
                    dueStatus = "Due Today";
                } else if (diffDays < 0) {
                    dueStatus = `${Math.abs(diffDays)} ${Math.abs(diffDays) === 1 ? "day" : "days"}`;
                } else {
                    dueStatus = `${diffDays} ${diffDays === 1 ? "day" : "days"}`;
                }
            }

            return {
                ...quotation,
                srNo: index + 1,
                customerName,
                issuedDateFormatted: issuedDate,
                statusText,
                dueStatusText: dueStatus
            };
        });
    };



    // Move the enriched data logic here to make it available for search
    const matchedInvoices = useMemo(() => {
        const filteredData = (selectedBusiness === null || selectedBusiness === "null")
            ? filterdInvoiceData
            : filterdInvoiceData.filter(invoice => invoice?.companyId == selectedBusiness);

        return enrichInvoiceData(filteredData);
    }, [filterdInvoiceData, selectedBusiness, state?.CUSTOMERS, state?.LANGUAGE]);
    function incrementLastPart(str) {

        const match = str?.match(/^(.*?)(\d+|[a-zA-Z])$/);

        if (!match) return str + "1"; // fallback

        const prefix = match[1];
        const lastPart = match[2];

        // If numeric
        if (!isNaN(lastPart)) {
            const incremented = (parseInt(lastPart) + 1)?.toString();
            return prefix + incremented;
        }

        // If single character (letter)
        const charCode = lastPart?.charCodeAt(0);
        let nextChar;

        if (lastPart >= 'a' && lastPart <= 'z') {
            nextChar = String.fromCharCode(charCode === 122 ? 97 : charCode + 1); // wrap 'z' → 'a'
        } else if (lastPart >= 'A' && lastPart <= 'Z') {
            nextChar = String.fromCharCode(charCode === 90 ? 65 : charCode + 1); // wrap 'Z' → 'A'
        } else {
            nextChar = lastPart;
        }

        return prefix + nextChar;
    }
    // Pagination logic - apply search BEFORE pagination
    const totalPages = Math.ceil(matchedInvoices?.length / itemsPerPage);

    useEffect(() => {
        // Select all elements with data-bs-toggle="DefaultTooltipThree"
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="DefaultTooltipThree"]');
        // Initialize tooltips
        const tooltipList = Array.from(tooltipTriggerList).map(
            (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl)
        );
        // Cleanup on unmount
        return () => {
            tooltipList.forEach((tooltip) => tooltip.dispose());
        };
    }, []);

    // open the menu manually
    const handleDropdownClick = (e, row) => {
        e.preventDefault();
        if (String(row?.status || "").toLowerCase() === "invoice") {
            setShowAlreadyInvoiceModal(true);
            return;
        }
        const menu = e.currentTarget.nextElementSibling;
        if (menu) menu.classList.toggle("show");
    };

    // close all menus on any click outside a .dropdown
    useEffect(() => {
        const closeAll = (event) => {
            if (!event.target.closest(".dropdown")) {
                document
                    .querySelectorAll(".dropdown-menu.show")
                    .forEach((el) => el.classList.remove("show"));
            }
        };
        document.addEventListener("click", closeAll);
        return () => document.removeEventListener("click", closeAll);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (state?.CUSTOMERS && Array.isArray(InvoicesData)) {
            const enriched = InvoicesData.map((invoice) => {
                const matchedCustomer = state.CUSTOMERS.find(
                    (cust) => cust.customerId === invoice.customerId
                );

                return {
                    ...invoice,
                    customerName: matchedCustomer?.customer || "Unknown",
                };
            });

            setEnrichedInvoices(enriched);
        }
    }, [state?.CUSTOMERS, InvoicesData]);

    const sortCaret = (order, column) => {
        return (
            <span className="d-inline-flex align-items-center ms-2" >
                {!order ? (
                    <Icon icon="mdi:swap-vertical" className="text-muted" />
                ) : order === "asc" ? (
                    <Icon icon="mdi:arrow-up-thick" className="text-muted" />
                ) : (
                    <Icon icon="mdi:arrow-down-thick" className="text-muted" />
                )}
            </span>
        );
    };

    const { SearchBar } = Search;

    const isPremium = state?.PREMIUM?.length > 0;
    const ConvertToInvoice = (row) => {
        try {
            const currentYear = new Date().getFullYear();

            const userPlanName =
                state?.PAYMENT?.[state?.PAYMENT?.length - 1]?.planName;

            const freeInvoiceLimit = parseInt(
                process.env.REACT_APP_FREE_PLAN_INVOICE_LIMIT || "2",
                10
            );

            const starterInvoiceLimit = parseInt(
                process.env.REACT_APP_STARTER_PLAN_INVOICE_LIMIT || "120",
                10
            );

            const starterPlanName = process.env.REACT_APP_STARTER_PLAN_NAME;
            const professionalPlanName = process.env.REACT_APP_PROFESSIONAL_PLAN_NAME;
            const agencyPlanName = process.env.REACT_APP_AGENCY_PLAN_NAME;

            // ✅ Count current year invoices
            const currentYearInvoices = (state?.INVOICES || []).filter(invoice => {
                const invoiceYear = new Date(parseInt(invoice.creationDate)).getFullYear();
                return invoiceYear === currentYear;
            }).length;

            const business = state?.BUSINESSES?.find(b => String(b.companyId) === String(row.companyId));
            const isSharedRow = business?.isShared === true;
            const targetUid = isSharedRow ? business?.ownerUid : null;

            // ======================
            // FREE PLAN
            // ======================
            if (!state?.PREMIUM && !isSharedRow) {
                if (currentYearInvoices >= freeInvoiceLimit) {
                    setIsDisplayFreePlanReachedModel(true);
                    return;
                }
            }

            // ======================
            // STARTER PLAN
            // ======================
            if (userPlanName === starterPlanName && !isSharedRow) {
                if (currentYearInvoices >= starterInvoiceLimit) {
                    setIsDisplayFreePlanReachedModel(true);
                    return;
                }
            }

            const currentStatus = String(row?.status || "").toLowerCase();

            if (currentStatus === "proforma invoice" || currentStatus === "proforma") {
                const proformaInvoice = state?.PROFORMAINVOICES?.find(
                    (invoice) => invoice?.invoiceId === row?.invoiceId
                );

                const uniqueId = proformaInvoice?.uniqueID;
                const newproformaInvoice = {
                    ...proformaInvoice,
                    converted: "true"
                };
                EditProformaInvoice(state, dispatch, uniqueId, newproformaInvoice, targetUid);
            }

            const doesExist = state?.INVOICES?.some(inv => inv.id === row?.id);


            let newInvoiceId;

            if (doesExist) {
                const lastInvoiceId = state?.INVOICES?.length
                    ? state?.INVOICES[0]?.id
                    : "";
                newInvoiceId = incrementLastPart(lastInvoiceId);
            } else {

                newInvoiceId = row?.id;
            }


            const updatedInvoice = {
                ...row,
                status: "Invoice",
            };
            const updatedInvoiceData = {
                ...row,
                id: newInvoiceId,
                customInvoiceId: row?.customInvoiceId
                    ? `QT-${row.customInvoiceId}`
                    : `QT-${row?.id}`,
                createdBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
            };


            AddInvoice(state, dispatch, updatedInvoiceData, targetUid);
            EditQuotation(state, dispatch, row?.uniqueID, updatedInvoice, targetUid);

            if (state?.USERID != null) {
                GetQuotationDataFirebase(state, dispatch);
            } else {
                GetQuotationDataLocal(state, dispatch);
            }

            toast.success("Converted to Invoice Successfully");
        } catch (error) {
            console.error("ConvertToInvoice error:", error);
            toast.error("Failed to convert to Invoice. Please try again.");
        }
    };


    const ConvertToProformaInvoice = (row) => {
        try {
            const business = state?.BUSINESSES?.find(b => String(b.companyId) === String(row.companyId));
            const isSharedRow = business?.isShared === true;
            const targetUid = isSharedRow ? business?.ownerUid : null;

            const isPremium = state?.PREMIUM;

            if (!isPremium && !isSharedRow) {
                const currentDate = new Date();
                const currentMonth = currentDate.getMonth();
                const currentYear = currentDate.getFullYear();

                const FREE_LIMIT = Number(process.env.REACT_APP_FREE_PLAN_PROFORMA_LIMIT) || 2;

                const currentMonthProformaCount =
                    state?.PROFORMAINVOICES?.filter(proforma => {
                        const biz = state?.BUSINESSES?.find(b => String(b.companyId) === String(proforma.companyId));
                        if (biz?.isShared) return false;
                        const proformaDate = new Date(Number(proforma.creationDate));
                        return (
                            proformaDate.getMonth() === currentMonth &&
                            proformaDate.getFullYear() === currentYear
                        );
                    }).length;

                if (currentMonthProformaCount >= FREE_LIMIT) {
                    setIsDisplayFreePlanReachedModel(true);
                    return;
                }
            }

            const doesExist = state?.PROFORMAINVOICES?.some(inv => inv.id === row?.id);

            let newInvoiceId;

            if (doesExist) {
                // Get latest proforma invoice id (safe sorting)
                const lastInvoiceId =
                    [...(state?.PROFORMAINVOICES || [])]
                        .sort((a, b) => Number(b.creationDate) - Number(a.creationDate))[0]?.id || "";

                // ⭐ Use your existing function
                newInvoiceId = incrementLastPart(lastInvoiceId);
            } else {
                newInvoiceId = row?.id;
            }


            const updatedInvoice = {
                ...row,
                status: "Proforma Invoice",
            };

            const updatedProformaInvoice = {
                ...row,
                converted: false,
                id: newInvoiceId,
                customInvoiceId: row?.customInvoiceId
                    ? `QT-${row.customInvoiceId}`
                    : `QT-${row?.id}`,
                createdBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
            };

            AddProformaInvoice(state, dispatch, updatedProformaInvoice, targetUid);
            EditQuotation(state, dispatch, row?.uniqueID, updatedInvoice, targetUid);

            if (state?.USERID != null) {
                GetQuotationDataFirebase(state, dispatch);
            } else {
                GetQuotationDataLocal(state, dispatch);
            }

            toast.success("Converted to Proforma Invoice Successfully");
        } catch (error) {
            console.error("ConvertToProformaInvoice error:", error);
            toast.error("Failed to convert to Proforma Invoice. Please try again.");
        }
    };


    useEffect(() => {
        if (currentPage > totalPages && totalPages > 0) {
            setCurrentPage(totalPages);
        }
    }, [totalPages, currentPage]);

    const handleDuplicate = (row) => {
        try {
            const business = state?.BUSINESSES?.find(b => String(b.companyId) === String(row.companyId));
            const isSharedRow = business?.isShared === true;
            const targetUid = isSharedRow ? business?.ownerUid : null;

            // Generate unique internal ID
            const newInvoiceUid = Date.now().toString() + Math.floor(Math.random() * 1000);

            // Generate unique ID (Serial Number) - Case Insensitive Check
            let newId = incrementLastPart(String(row.id));
            const allExistingIds = [
                ...(state?.INVOICES || []).map(inv => String(inv.id).toLowerCase()),
                ...(state?.PROFORMAINVOICES || []).map(inv => String(inv.id).toLowerCase()),
                ...(state?.QUOTATION || []).map(inv => String(inv.id).toLowerCase())
            ];

            while (allExistingIds.includes(newId.toLowerCase())) {
                newId = incrementLastPart(newId);
            }

            // Generate unique customInvoiceId if it exists - Case Insensitive Check
            let newCustomInvoiceId = row.customInvoiceId ? incrementLastPart(String(row.customInvoiceId)) : newId;
            const allExistingCustomIds = [
                ...((state?.INVOICES || []).map(inv => String(inv.customInvoiceId || inv.id).toLowerCase())),
                ...((state?.PROFORMAINVOICES || []).map(inv => String(inv.customInvoiceId || inv.id).toLowerCase())),
                ...((state?.QUOTATION || []).map(inv => String(inv.customInvoiceId || inv.id).toLowerCase()))
            ];

            if (row.customInvoiceId) {
                while (allExistingCustomIds.includes(newCustomInvoiceId.toLowerCase())) {
                    newCustomInvoiceId = incrementLastPart(newCustomInvoiceId);
                }
            }

            const duplicatedQuotation = {
                ...row,
                id: newId,
                invoiceId: newInvoiceUid,
                date: Date.now().toString(),
                creationDate: Date.now().toString(),
                customInvoiceId: newCustomInvoiceId,
                createdBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
                status: "Pending" // Reset status for duplicate
            };

            // Remove Firebase specific ID
            delete duplicatedQuotation.uniqueID;

            AddQuotation(state, dispatch, duplicatedQuotation, targetUid);
            toast.success("Quotation duplicated successfully");
        } catch (error) {
            console.error("Duplicate Quotation error:", error);
            toast.error("Failed to duplicate Quotation.");
        }
    };


    const columns = [
        {
            dataField: "srNo",
            text: Languages[state?.LANGUAGE]?.s_r,
            headerAlign: "center",
            align: "center",
            sort: true,
            formatter: (cell) => (
                <span style={{ marginLeft: -8 }}>{cell}</span>
            ),
            sortCaret: sortCaret,
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    OnClickOfRow(row?.invoiceId, row?.paidFlagKey);
                }
            }
        },
        {
            dataField: "customInvoiceId",
            text: Languages[state?.LANGUAGE]?.invoice_no,
            headerAlign: "center",
            align: "center",
            sort: true,
            formatter: (cell, row) => {
                const business = state?.BUSINESSES?.find(b => String(b.companyId) === String(row.companyId));
                const isShared = business?.isShared === true;

                const currentUserStr = state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest";
                const resolvedName = resolveAuditName(row.createdBy, state.membersData);
                const creatorName = (resolvedName === "Unknown" && business?.ownerName)
                    ? business.ownerName
                    : resolvedName;
                const isCreator = creatorName === currentUserStr || row.createdBy === currentUserStr || (typeof row.createdBy === 'object' && row.createdBy?.uid === state?.USERID);

                const showByLabel = row.createdBy
                    ? !isCreator
                    : (isShared && business?.ownerName);

                const displayName = row.createdBy ? creatorName : business?.ownerName;

                return (
                    <div style={{ marginLeft: -8 }}>
                        <div>{cell && cell.trim() !== "" ? cell : row?.id}</div>
                        {showByLabel && (
                            <small className="text-secondary-light" style={{ fontSize: '11px', display: 'block', marginTop: '-4px' }}>
                                by: {displayName}
                            </small>
                        )}
                    </div>
                );
            },
            sortCaret: sortCaret,
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    OnClickOfRow(row?.invoiceId, row?.paidFlagKey);
                }
            }
        },
        {
            dataField: "customerName", // Changed from "customerId" to "customerName"
            text: Languages[state?.LANGUAGE]?.customer_name,
            sort: true,
            style: { minWidth: "150px" },
            sortCaret: sortCaret,
            searchFormatted: true,
            formatter: (cell, row) => {
                const business = state?.BUSINESSES?.find(b => String(b.companyId) === String(row.companyId));
                const isShared = business?.isShared === true;

                const currentUserStr = state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest";
                const creatorName = resolveAuditName(row.createdBy, state.membersData);
                const isCreator = creatorName === currentUserStr || row.createdBy === currentUserStr || (typeof row.createdBy === 'object' && row.createdBy?.uid === state?.USERID);

                return (
                    <div style={{ marginLeft: -8, cursor: "pointer" }}>
                        <div>{cell || "Unknown"}</div>
                        {/* {row.createdBy && !isCreator && (
                        <small className="text-secondary-light" style={{ fontSize: '11px', display: 'block', marginTop: '-4px' }}>
                                by: {creatorName}
                            </small>
                        )} */}
                    </div>
                );
            },
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    OnClickOfRow(row?.invoiceId, row?.paidFlagKey);
                }
            }
        },
        {
            dataField: "totalAmount",
            text: Languages[state?.LANGUAGE]?.amount,
            sort: true,
            sortCaret: sortCaret,
            formatter: (cell, row) => {
                const matchedCurrency = row?.currency ? Currancy.CountryCurrencyResponse.find(
                    (c) => c.currencyCode === row.currency
                ) : null;
                const currencyCode = matchedCurrency ? matchedCurrency.currencyCode : state?.CURRENCYCODE;
                const currencySymbol = matchedCurrency ? matchedCurrency.currencytSymbol : state?.SYMBOL;
                return (
                    <span>{currencySymbol === "$" ? `${currencyCode} ${currencySymbol} ` : `${currencySymbol} `} {cell}</span>
                );
            },
            sortFunc: (a, b, order) => {
                if (order === 'asc') {
                    return Number(a) - Number(b);
                }
                return Number(b) - Number(a);
            },
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    OnClickOfRow(row?.invoiceId, row?.paidFlagKey);
                }
            }
        },
        {
            dataField: "issuedDateFormatted", // Changed from "date" to use formatted date
            text: Languages[state?.LANGUAGE]?.issued_date,
            formatter: (cell) => cell, // Just return the already formatted date
            sort: true,
            style: { minWidth: "100px" },
            sortCaret: sortCaret,
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    OnClickOfRow(row?.invoiceId, row?.paidFlagKey);
                }
            }
        },
        {
            dataField: "statusText",
            text: Languages[state?.LANGUAGE]?.status,
            formatter: (cell, row) => {
                const status = String(cell || "").toLowerCase();
                const isInvoice = status === "invoice";
                const isProforma = status === "proforma invoice" || status === "proforma";

                return (
                    <span className={`d-inline-block text-center px-24 py-4 rounded-pill fw-medium text-sm
                        ${isInvoice
                            ? "bg-success-focus text-success-main"
                            : isProforma
                                ? "bg-primary-light text-primary-600"
                                : "bg-warning-focus text-warning-main"}
                    `}>
                        {isInvoice ? "Invoice" : isProforma ? "Proforma Invoice" : "Pending"}
                    </span>
                );
            },
            sort: true,
            sortCaret: sortCaret,
            searchable: true,
            // tell search to use statusText
            hidden: false,
        },
        {
            dataField: "dueStatusText",
            text: "Due Status",
            headerAlign: "center",
            align: "center",
            formatter: (cell, row) => {
                if (!row.dueDate) {
                    return (
                        <span className="d-inline-block text-center px-16 py-4 rounded-pill fw-medium text-sm bg-danger-focus text-danger-main">
                            No Due Date
                        </span>
                    );
                }

                let dueDateNum = parseInt(row.dueDate);
                if (dueDateNum.toString().length === 10) {
                    dueDateNum = dueDateNum * 1000;
                }

                const dueDate = new Date(dueDateNum);
                const today = new Date();
                dueDate.setHours(0, 0, 0, 0);
                today.setHours(0, 0, 0, 0);
                const diffTime = dueDate.getTime() - today.getTime();
                const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

                if (diffDays === 0) {
                    return (
                        <span className="d-inline-block text-center px-16 py-4 rounded-pill fw-medium text-sm bg-warning-focus text-warning-main">
                            Due Today
                        </span>
                    );
                } else if (diffDays < 0) {
                    return (
                        <span className="d-inline-block text-center px-16 py-4 rounded-pill fw-medium text-sm bg-danger-focus text-danger-main">
                            {Math.abs(diffDays)} {Math.abs(diffDays) === 1 ? "day" : "days"}
                        </span>
                    );
                } else {
                    return (
                        <span className="d-inline-block text-center px-16 py-4 rounded-pill fw-medium text-sm bg-success-focus text-success-main">
                            {diffDays} {diffDays === 1 ? "day" : "days"}
                        </span>
                    );
                }
            },
            sort: true,
            sortCaret: sortCaret,
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    OnClickOfRow(row?.invoiceId, row?.paidFlagKey);
                }
            }
        },
        {
            dataField: "action",
            text: Languages[state?.LANGUAGE]?.action,
            headerAlign: "center",
            align: "center",
            formatter: (cell, row) => (
                <>
                    <Link
                        onClick={(e) => {
                            if (!state?.USERID) {
                                e.preventDefault();
                                dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                return;
                            }
                            dispatch({ type: actionType.SELECTEDQUOTATION, payload: row?.invoiceId });
                        }}
                        to="/invoice-preview"
                        className="w-32-px h-32-px me-8 bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                        data-bs-toggle="DefaultTooltipThree"
                        data-bs-placement="top"
                        data-bs-custom-class="tooltip-primary"
                        data-bs-title="View Quotation"
                    >
                        <Icon icon="iconamoon:eye-light" />
                    </Link>
                    <Link
                        onClick={(e) => {
                            if (!state?.USERID) {
                                e.preventDefault();
                                dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                return;
                            }
                            dispatch({ type: actionType.SELECTEDQUOTATION, payload: row?.invoiceId });
                        }}
                        to="/quotation-edit"
                        className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                        data-bs-toggle="DefaultTooltipThree"
                        data-bs-placement="top"
                        data-bs-custom-class="tooltip-success"
                        data-bs-title="Edit Quotation"
                    >
                        <Icon icon="lucide:edit" />
                    </Link>
                    <Link
                        data-bs-toggle="DefaultTooltipThree"
                        data-bs-placement="top"
                        data-bs-custom-class="tooltip-danger"
                        data-bs-title="Delete Quotation"
                    >
                        <DeleteQuotationView FirebaseId={row?.uniqueID} />
                    </Link>
                    <Link
                        onClick={(e) => {
                            if (!state?.USERID) {
                                e.preventDefault();
                                dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                return;
                            }
                            handleDuplicate(row);
                        }}
                        className="w-32-px h-32-px me-8 bg-info-focus text-info-main rounded-circle d-inline-flex align-items-center justify-content-center"
                        data-bs-toggle="DefaultTooltipThree"
                        data-bs-placement="top"
                        data-bs-custom-class="tooltip-info"
                        data-bs-title="Duplicate Quotation"
                    >
                        <Icon icon="lucide:copy" />
                    </Link>
                    <div className="dropdown d-inline-block me-8">
                        <button
                            className="btn bg-primary-light text-primary-600 rounded-circle p-0 w-32-px h-32-px d-flex align-items-center justify-content-center"
                            type="button"
                            onClick={(e) => handleDropdownClick(e, row)}
                        >
                            <Icon icon="lucide:more-vertical" />
                        </button>

                        {(() => {
                            const currentStatus = String(row?.status || "").toLowerCase();
                            const isInvoice = currentStatus === "invoice";
                            const isProforma = currentStatus === "proforma invoice" || currentStatus === "proforma";

                            if (isInvoice) return null;

                            return (
                                <ul className="dropdown-menu dropdown-top-left shadow-sm border-0 rounded-3 hide-scrollbar">
                                    {isProforma && (
                                        <li>
                                            <button
                                                className="dropdown-item rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                                onClick={(e) => {
                                                    if (!state?.USERID) {
                                                        dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                                        return;
                                                    }
                                                    ConvertToInvoice(row);
                                                    e.currentTarget.closest(".dropdown")
                                                        ?.querySelector(".dropdown-menu")
                                                        ?.classList.remove("show");
                                                }}
                                            >
                                                Convert to Invoice
                                            </button>
                                        </li>
                                    )}

                                    {!isInvoice && !isProforma && (
                                        <>
                                            <li>
                                                <button
                                                    className="dropdown-item rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                                    onClick={(e) => {
                                                        if (!state?.USERID) {
                                                            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                                            return;
                                                        }
                                                        ConvertToInvoice(row);
                                                        e.currentTarget.closest(".dropdown")
                                                            ?.querySelector(".dropdown-menu")
                                                            ?.classList.remove("show");
                                                    }}
                                                >
                                                    Convert to Invoice
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    className="dropdown-item rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                                    onClick={() => {
                                                        if (!state?.USERID) {
                                                            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                                            return;
                                                        }
                                                        ConvertToProformaInvoice(row);
                                                    }}
                                                >
                                                    Convert to Proforma Invoice
                                                </button>
                                            </li>
                                        </>
                                    )}
                                </ul>
                            );
                        })()}
                    </div>
                </>
            ),
        }
    ];

    const OnClickOfRow = (invoiceId, isPaid) => {
        if (!state?.USERID) {
            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
            return;
        }
        dispatch({ type: actionType.SELECTEDQUOTATION, payload: invoiceId })
        if (isPaid == "true" || isPaid == true) {
            navigate("/invoice-preview")
        }
        else {
            navigate("/quotation-edit")
        }
    }

    const handleSelection = (val) => {
        setItemsPerPage(val)
        setCurrentPage(1)
    };

    return (
        <div className="card">
            <div className="card-body">
                <ToolkitProvider
                    keyField="invoiceId"
                    data={matchedInvoices}
                    columns={columns}
                    search
                >
                    {props => {
                        const searchText = props.searchProps.searchText?.toLowerCase() || "";
                        const filteredSearchData = matchedInvoices.filter(q =>
                            q.id?.toString()?.toLowerCase().includes(searchText) ||
                            q.customerName?.toLowerCase()?.includes(searchText) ||
                            q.issuedDateFormatted?.toLowerCase()?.includes(searchText) ||
                            q.statusText?.toLowerCase()?.includes(searchText) ||
                            q.dueStatusText?.toLowerCase()?.includes(searchText) ||
                            q.totalAmount?.toString()?.toLowerCase().includes(searchText) ||
                            q.customInvoiceId?.toString()?.toLowerCase().includes(searchText)
                        );

                        const start = (currentPage - 1) * itemsPerPage;
                        const paginatedData = filteredSearchData.slice(start, start + itemsPerPage);

                        return (
                            <>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <SearchBar {...props.searchProps} placeholder={"Search Quotations..."} className="form-control w-auto" />
                                </div>
                                <div className="table-responsive">
                                    <BootstrapTable
                                        {...props.baseProps}
                                        bootstrap4
                                        bordered={false}
                                        data={paginatedData}
                                        wrapperClasses={`custom-table-border quotation-table ${localStorage.getItem("theme") === "dark" ? "table-dark" : "table-light"}`}
                                        defaultSorted={{ dataField: "date", order: "desc" }}
                                        noDataIndication={() => <DataNotFoundView height={400} />}
                                        rowStyle={{ cursor: "pointer" }}
                                    />
                                </div>

                                {filteredSearchData.length > 0 && (
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <div className="d-flex align-items-center gap-2 entry_per_page">
                                            <div className="dropdown">
                                                <button
                                                    className="btn btn-outline-primary-600 not-active px-18 py-6 dropdown-toggle toggle-icon"
                                                    type="button"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    {itemsPerPage}
                                                </button>
                                                <ul className="dropdown-menu shadow-md">
                                                    {[5, 10, 15, 20].map((value) => (
                                                        <li key={value}>
                                                            <Link
                                                                className={`dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 ${itemsPerPage == value && "bg-primary-50"}`}
                                                                onClick={() => handleSelection(value)}
                                                            >
                                                                {value}
                                                            </Link>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            <span className="text-secondary-light">{Languages[state?.LANGUAGE]?.entries_per_page}</span>
                                        </div>

                                        <div className="ms-auto">
                                            <PaginationView
                                                currentPage={currentPage}
                                                totalPages={Math.ceil(filteredSearchData.length / itemsPerPage)}
                                                handlePageChange={setCurrentPage}
                                            />
                                        </div>
                                    </div>
                                )}
                            </>
                        );
                    }}
                </ToolkitProvider>

                <PremiumFeatureOnlyModal
                    isOpen={isDisplayPrimiumFeatureModel}
                    onClose={() => setIsDisplayPrimiumFeatureModel(false)}
                    featureName="Sales-Return"
                />

                <Modal
                    show={showAlreadyInvoiceModal}
                    onHide={() => setShowAlreadyInvoiceModal(false)}
                    centered
                >
                    <Modal.Body className="text-center px-4 py-5">
                        <img
                            src="https://cdn-icons-png.flaticon.com/512/5957/5957610.png"
                            alt="Already Invoice"
                            className="mb-4"
                            style={{ width: "100px", height: "100px" }}
                        />
                        <h5 className="mb-3 fw-semibold text-primary">Invoice Already Created</h5>
                        <p className="text-secondary">
                            This record has already been converted into an invoice. No further changes can be made.
                        </p>
                        <Button
                            variant="primary"
                            onClick={() => setShowAlreadyInvoiceModal(false)}
                            className="mt-3 px-5 text-white fw-semibold"
                        >
                            Got It
                        </Button>
                    </Modal.Body>
                </Modal>

                <FreePlanLimitReachedModal
                    isOpen={isDisplayFreePlanReachedModel}
                    onClose={() => setIsDisplayFreePlanReachedModel(false)}
                    limit={5}
                    type={"invoice"}
                />
            </div>
        </div>
    );
};

export default QuotationTableDataLayer;